import { render, staticRenderFns } from "./AlphabetPagination.vue?vue&type=template&id=72b7e81a&lang=pug&"
import script from "./AlphabetPagination.vue?vue&type=script&lang=js&"
export * from "./AlphabetPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VSelect})
